// Extracted from `pages/CustomerDetailPage.js` (P2 refactor step 3).
// Modal "Editar Ubicación / Sede" — 1:1 move del JSX; recibe estado
// y handlers del padre como props.
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Save } from "lucide-react";

export const EditLocationModal = ({
  open,
  onOpenChange,
  editingLocation,
  setEditingLocation,
  handleUpdateLocation,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-[#0A0A35] border-[#1E1E5F] text-white max-w-lg"
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="text-white font-heading">
            Editar Ubicación / Sede
          </DialogTitle>
        </DialogHeader>
        {editingLocation && (
          <div className="space-y-4 mt-4">
            <div>
              <Label className="text-slate-300">Nombre Sede *</Label>
              <Input
                value={editingLocation.nombre_sede}
                onChange={(e) => setEditingLocation({ ...editingLocation, nombre_sede: e.target.value })}
                className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white"
              />
            </div>
            <div>
              <Label className="text-slate-300">Dirección Completa *</Label>
              <Input
                value={editingLocation.direccion_completa}
                onChange={(e) => setEditingLocation({ ...editingLocation, direccion_completa: e.target.value })}
                className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className="text-slate-300">Código Postal</Label>
                <Input
                  value={editingLocation.codigo_postal || ""}
                  onChange={(e) => setEditingLocation({ ...editingLocation, codigo_postal: e.target.value })}
                  className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white"
                />
              </div>
              <div>
                <Label className="text-slate-300">Ciudad</Label>
                <Input
                  value={editingLocation.ciudad || ""}
                  onChange={(e) => setEditingLocation({ ...editingLocation, ciudad: e.target.value })}
                  className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white"
                />
              </div>
            </div>
            <div>
              <Label className="text-slate-300">Contacto Técnico Sede</Label>
              <Input
                value={editingLocation.contacto_tecnico_sede || ""}
                onChange={(e) => setEditingLocation({ ...editingLocation, contacto_tecnico_sede: e.target.value })}
                className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white"
              />
            </div>
            <div>
              <Label className="text-slate-300">Teléfono Sede</Label>
              <Input
                value={editingLocation.telefono_sede || ""}
                onChange={(e) => setEditingLocation({ ...editingLocation, telefono_sede: e.target.value })}
                className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white"
              />
            </div>
            <div>
              <Label className="text-slate-300">Información Adicional</Label>
              <Textarea
                value={editingLocation.informacion_adicional || ""}
                onChange={(e) => setEditingLocation({ ...editingLocation, informacion_adicional: e.target.value })}
                rows={3}
                className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white"
              />
            </div>
            <div className="flex justify-end gap-3 pt-4">
              <Button
                variant="outline"
                onClick={() => {
                  onOpenChange(false);
                  setEditingLocation(null);
                }}
                className="border-[#1E1E5F] text-slate-300"
              >
                Cancelar
              </Button>
              <Button onClick={handleUpdateLocation} className="bg-[#42E695] text-[#04042C]">
                <Save className="h-4 w-4 mr-2" />
                Guardar Cambios
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
